// extracted by mini-css-extract-plugin
export default {"root":"WDVC6cqljN_mFHbU7Tja","msg":"jINO5eqA_fxH7KZSPlVe","placeHolderShimmer":"I4ZvU9qdryUMQxi6Bb0i"};